import React from 'react'
import { BaseDialog } from '@/components/dialog/base-dialog'

import './member-record-detail.scss'

export interface MemberRecordDetailItem {
    label: string
    value: React.ReactNode
    wide?: boolean
}

export interface MemberRecordDetailSection {
    title: string
    items: MemberRecordDetailItem[]
}

interface Props {
    title: string
    sections: MemberRecordDetailSection[]
    onClose: () => void
}

const MemberRecordDetail: React.FC<Props> = ({ title, sections, onClose }) => (
    <div className="member-record-detail-layer">
        <BaseDialog isShow title={title} width={720} onClose={onClose}>
            <div className="member-record-detail">
                {sections.map(section => (
                    <section className="member-record-detail__section" key={section.title}>
                        <div className="member-record-detail__section-title">{section.title}</div>
                        <div className="member-record-detail__grid">
                            {section.items.map(item => (
                                <div
                                    className={
                                        item.wide
                                            ? 'member-record-detail__item member-record-detail__item--wide'
                                            : 'member-record-detail__item'
                                    }
                                    key={item.label}
                                >
                                    <div className="member-record-detail__label">{item.label}</div>
                                    <div className="member-record-detail__value">{item.value}</div>
                                </div>
                            ))}
                        </div>
                    </section>
                ))}
            </div>
        </BaseDialog>
    </div>
)

export default MemberRecordDetail
